/**
 * Language and country code mappings for autosuggest API integration.
 * Maps application locale codes to Kayak-compatible country/language codes.
 */

export const countryLanguageMap: Record<string, string> = {
	ar: 'SA',
	he: 'IL',
	zh: 'HK',
}

/**
 * Get uppercase language code for API calls
 * @param language - App language code (e.g., 'en', 'ar')
 * @returns Uppercase language code (e.g., 'EN', 'SA')
 */
export const getLanguageCode = (language: string): string => {
	return language
}
